// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TW7r","title":"Header_title__PBnqW","side":"Header_side__1PqER"};